<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<div class="container">
  <div class="row">
    <div class="col-12">
        <div class="card">
            <form [formGroup]="petregistrationform"  (ngSubmit)=" doRegister()">
              <div class="card-body">
                  <div class="form-group">
                      <label for="Pet_name"> Pet Name</label>
                      <input type="text" name="Pet_name" id="Pet_name" [(ngModel)]="petregistrationform.Pet_name" class="form-control" formControlName="Pet_name" required >
                      </div>
                      <div  *ngIf="( petregistrationform.get('Pet_name').hasError('required') ) && petregistrationform.get('Pet_name').touched">

                              <div class="error" style="color:red;font-size:20px" *ngIf="petregistrationform.get('Pet_name').hasError('required') && petregistrationform.get('Pet_name').touched">
                              Pet Name is required
                            </div>
                      </div>

                      <div class="form-group">
                          <label for="Pet_type">Pet Type</label>
                          <select type="text" name="Pet_type" id="Pet_type" [(ngModel)]="petregistrationform.Pet_type" class="form-control" formControlName="Pet_type" required >
                          <option value='dog'>
                            Dog
                          </option>
                          <option value='cat'>
                              Cat
                            </option>
                            <option value='Birds'>
                                Birds
                              </option>
                              <option value='Rabbit/Hamsters'>
                                Rabbit/Hamsters
                                </option>
                                <option value='Others'>
                                    Others
                                  </option>
                        
                          </select>
                          </div>
                          <div class="row">
                              <div class="form-group">
                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6   text-right ">
                                  <label for="dob" style="color:#000">Date of Birth: </label>
                                  <mat-form-field>
                                      <input type="date" time="false" date="true" name="dob" displayFormat="MMM DD YYYY"    [(ngModel)]="dob"
                                      [ngModelOptions]="{standalone: true}" >
                                  </mat-form-field>
                                     <mat-datepicker name="dob" id="dob" #myDatepicker></mat-datepicker>
                                      </div>
                         </div>
                            </div>

                          <div  *ngIf="( petregistrationform.get('Pet_type').hasError('required') ) && petregistrationform.get('Pet_type').touched">

                                  <div class="error" style="color:red;font-size:20px" *ngIf="petregistrationform.get('Pet_type').hasError('required') && petregistrationform.get('Pet_type').touched">
                                  Pet Type is required
                                 </div>
                           </div>
              </div>
              <div class="card-footer">
                     <div class="row" style="margin-top: 2%">
                       <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <button class="btn btn-success btn-block" type="submit"  [disabled]="!petregistrationform.valid">Register</button>
                       </div>
                       <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                          <button class="btn btn-success3 btn-block"   routerLink="/manageprofile/manageyourpet">Cancel</button>
                        </div>
                     </div>
                    </div>
                    </form>
        </div>
    </div>
  </div>
</div>
